import {
    getBrandDeviceName,
    getVersionedDeviceName,
} from '../hooks/useBrandConfig'

const stopByteCondition = ({ connectedDevice, deviceVersion }) => {
    const PLAY_BYTES = [
        'P'.charCodeAt(0),
        'L'.charCodeAt(0),
        'A'.charCodeAt(0),
        'Y'.charCodeAt(0),
    ]

    try {
        const STOP_BYTES = [
            'S'.charCodeAt(0),
            'T'.charCodeAt(0),
            'O'.charCodeAt(0),
            'P'.charCodeAt(0),
        ]
        let sendStopBytes = PLAY_BYTES

        const stopConditions = [
            { device: 'Humanoid', minVersion: 4, startsWith: 2 },
            { device: 'Hexapod', minVersion: 3, startsWith: 2 },
            { device: 'Ace', minVersion: 7, startsWith: 1 },
            { device: 'Roboki', minVersion: 3 },
        ]

        if (
            stopConditions.some(
                ({ device, minVersion, startsWith }) =>
                    connectedDevice === device &&
                    (!startsWith ||
                        Number((deviceVersion?.split('.') || '0')[0]) >=
                            startsWith) &&
                    // (!startsWith || deviceVersion?.startsWith(startsWith)) &&
                    (device === 'Humanoid'
                        ? parseInt(deviceVersion?.split('.')?.[2] ?? '0')
                        : parseInt(deviceVersion?.slice(-1))) >= minVersion
            ) ||
            [
                'Klaw',
                'Logiki',
                'Toki',
                'Poki',
                'Atr',
                'Moki',
                'Autoki',
            ].includes(connectedDevice)
        ) {
            sendStopBytes = STOP_BYTES
        }

        return sendStopBytes
    } catch (e) {
        console.error(e)
        return PLAY_BYTES
    }
}

//ai not pracent for the following device and version
const isAi1NotPresent = ({ connectedDevice, deviceVersion }) => {
    const deviceList = [
        { device: 'Humanoid', startsWith: '1' },
        { device: 'Hexapod', startsWith: '1' },
        // { device: 'Hexapod', startsWith: '2' },
        { device: 'Ace', startsWith: '0' },
        // { device: 'Roboki', startsWith: '1' },
        { device: 'Moki', startsWith: '1' },
        { device: 'Toki', startsWith: '1' },
        { device: 'Autoki', startsWith: '1' },

        { device: 'Poki', startsWith: '1' },
    ]

    if (
        deviceList.some(
            ({ device, startsWith }) =>
                connectedDevice === device &&
                (!startsWith || deviceVersion?.startsWith(startsWith))
        )
    ) {
        return true
    }

    return false
}

//check the Ai-1 is show for which device and which version
const isAi1ShowCondition = ({ connectedDevice, deviceVersion }) => {
    try {
        // return deviceConditions[connectedDevice]?.(deviceVersion) ?? false
        const stopConditions = [
            { device: 'Humanoid', minVersion: 5, startsWith: 2 },
            { device: 'Hexapod', minVersion: 3, startsWith: 2 },
            { device: 'Ace', minVersion: 8, startsWith: 1 },
            { device: 'Roboki', minVersion: 3, startsWith: 1 },
        ]

        // Patch number is the 3rd segment; 4-part hotfix versions (e.g. 1.1.12.0) must not use the last one.
        const majorVersion = Number(deviceVersion?.split('.')?.[0] || 0)
        const minorVersion = Number(deviceVersion?.split('.')?.[2] || 0)

        if (
            stopConditions.some(({ device, minVersion, startsWith }) => {
                if (connectedDevice === device) {
                    if (majorVersion == startsWith) {
                        return minorVersion >= minVersion
                    } else if (majorVersion > startsWith) {
                        return true
                    } else return false
                } else return false
            }) ||
            ['Klaw', 'Atr'].includes(connectedDevice)
        ) {
            return true
        }

        return false
    } catch (e) {
        console.error(e)
        return false
    }
}

//delete the aiTranlist data from the localstorage if connectDevice change.
// const ifAiTranDataDelete = (device) => {
//     console.log(device)
//     try {
//         const aiTrainList = JSON.parse(localStorage.getItem('aiTrainList'))
//         // const connectedDevice = sessionStorage.getItem('connectedDevice')
//         if (device !== aiTrainList?.connectedDevice) {
//             localStorage.removeItem('aiTrainList')
//         }
//     } catch (e) {
//         console.error(e)
//         localStorage.removeItem('aiTrainList')
//     }
// }

const getDeviceName = (connectedDevice) =>
    connectedDevice ? getBrandDeviceName(connectedDevice) : connectedDevice

const getDeviceNameWithVersion = (connectedDevice, deviceVersion = '1.0.0') => {
    const versionLabel = `(v${deviceVersion.split('.').slice(0, 2).join('.')})`
    const name = connectedDevice
        ? getVersionedDeviceName(connectedDevice, deviceVersion)
        : getBrandDeviceName('Ace')
    return `${name} ${versionLabel}`
}

//check the if connected device is Atr test the pwm output  is share or not
const checkIsPwmOutput = (component) => {
    return [
        'led_1c',
        'led',
        'dc_motor',
        'mini_geared_motor',
        'servo_motor',
        'servo_motor_270',
        'servo_motor_360',
    ].includes(component)
}

// Live write frames sent while a Live button is on.
//   Servo / motor: L A <S|R|P> <port> <value> [<S|R|P> <port> <value> ...] E R
//   Other outputs: L W <type> <port> <value>
// Builds the LA...ER frame from [type, port, value] entries, e.g. both ports
// of a motor (M1 + M2) in one frame.
const liveWriteAllFrame = (entries) => [
    'L'.charCodeAt(0),
    'A'.charCodeAt(0),
    ...entries.flat(),
    'E'.charCodeAt(0),
    'R'.charCodeAt(0),
]

// Takes the LW frame and returns the LA...ER frame for servos and motors,
// or the LW frame unchanged otherwise.
const toLiveWriteFrame = (lwData, component) => {
    if (
        ![
            'geared_motor',
            'mini_geared_motor',
            'dc_motor',
            'dynamex_motor',
            'servo_motor',
            'servo_motor_270',
            'servo_motor_sg90',
            'servo_motor_360',
            'AtrMotor',
        ].includes(component)
    )
        return lwData
    return liveWriteAllFrame([lwData.slice(2, 5)])
}

export {
    stopByteCondition,
    isAi1ShowCondition,
    // ifAiTranDataDelete,
    getDeviceName,
    isAi1NotPresent,
    getDeviceNameWithVersion,
    checkIsPwmOutput,
    liveWriteAllFrame,
    toLiveWriteFrame,
}
